export function formatGliderDate(value?: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

/** Format a date as a human-readable relative period, e.g. "3 weeks ago", "15 months ago". */
export function timeAgo(value?: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'

  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  if (diffMs < 0) return 'in the future'

  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24))
  if (days === 0) return 'today'
  if (days === 1) return 'yesterday'
  if (days < 14) return `${days} days ago`

  const weeks = Math.floor(days / 7)
  if (weeks < 9) return `${weeks} weeks ago`

  const months = Math.floor(days / 30.44) // average days per month
  if (months < 24) return `${months} month${months !== 1 ? 's' : ''} ago`

  const years = Math.floor(days / 365.25)
  return `${years} year${years !== 1 ? 's' : ''} ago`
}

export function toDateInputValue(value?: string | null): string {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toISOString().slice(0, 10)
}
